import { render, staticRenderFns } from "./WithdrawRequest.vue?vue&type=template&id=52cc28f7&"
import script from "./WithdrawRequest.vue?vue&type=script&lang=ts&"
export * from "./WithdrawRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports